import type { ReferralStatus } from './enums';

export const REFERRAL_STAFF_TRANSITIONS: Record<ReferralStatus, readonly ReferralStatus[]> = {
  draft: [],
  submitted: ['under_review', 'needs_clarification', 'reviewed', 'archived'],
  needs_clarification: ['submitted', 'archived'],
  under_review: ['needs_clarification', 'reviewed', 'archived'],
  reviewed: ['under_review', 'archived'],
  archived: ['under_review'],
};

export function allowedReferralTransitions(from: ReferralStatus): readonly ReferralStatus[] {
  return REFERRAL_STAFF_TRANSITIONS[from];
}

export function canStaffTransitionReferral(from: ReferralStatus, to: ReferralStatus): boolean {
  return REFERRAL_STAFF_TRANSITIONS[from].includes(to);
}

export const REFERRAL_STATUS_REASON_MAX = 2000;
export const INVALID_REFERRAL_TRANSITION = 'INVALID_REFERRAL_TRANSITION';
export const REFERRAL_STATUS_CHANGED = 'REFERRAL_STATUS_CHANGED';
